module.exports = __webpack_public_path__ + "static/media/14.6c3e41eb.png";